export type JourneyEvent = {
  year: number
  title: string
  description: string
  images: {
    src: string
    caption: string
  }[]
}

export const startYear = 2019
export const currentYear = new Date().getFullYear()

export const journey: JourneyEvent[] = [
  {
    year: 2019,
    title: 'The Beginning',
    description:
      'Camp David Prayer Platform was born — a small gathering of believers united by a hunger for the presence of God.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/mDxpugHH95QEhpUPmdQSJX/Hospital_Outreach_April_2019..jpg',
        caption: 'Hospital Outreach — April 2019',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/dKBQ6L5jbWwMPYps2YUiFG/Orphanage_Outreach_May_2019.(1).jpg',
        caption: 'Orphanage Outreach — May 2019',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/pfKQ9bFQ3aX6CPuQdwEkXx/Orphanage_Outreach_May_2019..jpg',
        caption: 'Orphanage Outreach — May 2019',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/ugVPRBnfPYXGavaxs1cf8e/Orphanage_Outreach,_October_2019..jpg',
        caption: 'Orphanage Outreach — October 2019',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/45ZwRUSfaVNnnSRPnP1Tqb/Hospital_Outreach_April_2019.(1).jpg',
        caption: 'Hospital Outreach — April 2019',
      },
    ],
  },
  {
    year: 2020,
    title: 'Growing in Faith',
    description:
      'Through the global pandemic, we held fast in prayer — online vigils carried us and our community through uncertainty.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/u5xL7T163TbkUdRshqGPKF/Hospital_Outreach,_March_2020..jpg',
        caption: 'Hospital Outreach — March 2020',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/iuNZ1boJ1rWs2aEgh7Kfng/Hospital_Outreach,_March_2020.(1).jpg',
        caption: 'Hospital Outreach — March 2020',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/1Ja23DTowJpE8115JKiFdm/End_of_year_Prayer_Retreat,_December_2020.(1).jpg',
        caption: 'End of Year Prayer Retreat — December 2020',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/f2TeXzXfFG4tmuqJoTBko8/End_of_year_Prayer_Retreat,_December_2020.(2).jpg',
        caption: 'End of Year Prayer Retreat — December 2020',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/tH7ZwVo8HZkvEnwzvuoNKx/End_of_year_Prayer_Retreat,_December_2020..jpg',
        caption: 'End of Year Prayer Retreat — December 2020',
      },
    ],
  },
  {
    year: 2021,
    title: 'Expanding Our Reach',
    description:
      'Reopening with renewed fire — outreaches resumed and new programs were birthed to serve the community.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/rv1HyRyAzteGefUqnYTmES/LDG_APRIL_B_2021.jpg',
        caption: 'Last Day Gathering — April 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/mZ2bFiiR9qHPtAfUhfVgA6/Hospital_Outreach_photo2_28th_February_2021.jpg',
        caption: 'Hospital Outreach — February 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/jkdf48DHFpfoUMSLn3Qv9N/Orphanage_Outreach_May_2021_A_(1).jpg',
        caption: 'Orphanage Outreach — May 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/rQYzkmMbQA1tVtfeViPZaW/Orphanage_Outreach_May_2021_G.jpg',
        caption: 'Orphanage Outreach — May 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/owYsCmYaP2VoQQ9q23enNc/Last_Day_Gathering_January_2021.jpg',
        caption: 'Last Day Gathering — January 2021',
      },
    ],
  },
  {
    year: 2022,
    title: 'NIWALE is Born',
    description:
      'The Night Watchers Legislation began — gathering intercessors monthly to stand in the gap for our nation.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/e9xhoLDqM9EFBbRubhqEa1/Market_Outreach_January_2022.jpg',
        caption: 'Market Outreach — January 2022',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/gaUkoDXmgXD5KeXsSLQ92i/Orphanage_Outreach_.jpg',
        caption: 'Orphanage Outreach — Holy Child Shelter & Orphanage Home',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/aNcXWEWFSta4PFj4mMPCCZ/Village_Outreach_October_2022.jpg',
        caption: 'Village Outreach — October 2022',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/ok9sge7CVZm9tfa3ZYukVQ/Correctional_Center_Outreach_August_2022.jpg',
        caption: 'Correctional Center Outreach — August 2022',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/xiejcaqTmQUtVpWL6V3LyJ/Love_Feast__Appreciation_Service_December_2022.jpg',
        caption: 'Love Feast & Appreciation Service — December 2022',
      },
    ],
  },
  {
    year: 2023,
    title: 'Hands That Heal',
    description:
      'Hospital outreaches at Christ Medical and Zimran — bringing prayer, comfort, and tangible help to the sick.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/4EJhRCzAdCZX6xwBDWXrpp/Hospital_Outreach._March.jpg',
        caption: 'Hospital Outreach — March 2023',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/nXBwUREEYubNDKhE6kPTBX/Orphanage_Outreach,_December.jpg',
        caption: 'Orphanage Outreach — Ajebor Orphanage Home, December 2023',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/rKGfSkSgmD1oYCFQ3p5nZs/Orphanage_Outreach,_December_.jpg',
        caption: 'Orphanage Outreach — December 2023',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/m1X7Zg2tiC6nsRKdDgXBp7/Orphanage_Outreach,_May.jpg',
        caption: 'Orphanage Outreach — May 2023',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/28p5BBY6JarGEDtf4ccLRZ/Market_Outreach.jpg',
        caption: 'Market Outreach — 2023',
      },
    ],
  },
  {
    year: 2024,
    title: 'Christ Love at Christmas',
    description:
      'Visiting Ajebor Orphanage and other homes — sharing love, gifts, and the message of Christ at Christmas.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/1ckvGetLSoGqPtpvPLqXgw/Market_Outreach_January_2024.jpg',
        caption: 'Market Outreach — January 2024',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/x5tZCsLKU1bihViuhWtMYS/Hospital_Outreach_Mar_2024.jpg',
        caption: 'Hospital Outreach — March 2024',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/b5TaofHHWYiui8JAa8tuwM/Orphanage_Outreach_May_2024.jpg',
        caption: 'Orphanage Outreach — Eghosa Orphanage Home, May 2024',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/tsjSMcHaGLQY1AnRGFfNqa/Mid-Year_Rereat_June_2024.jpg',
        caption: 'Mid-Year Prayer Retreat — June 2024',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/kXqmgdPwXDGTJNPDxv5oHA/Correctional_Center_Outreach_2024.jpg',
        caption: 'Correctional Center Outreach — 2024',
      },
    ],
  },
  {
    year: 2025,
    title: 'A Wider Mission Field',
    description:
      'New campuses, new partnerships, deeper impact — Camp David spreads beyond Benin City.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/vkDXZDQg7dvwozg54jYYQx/Correctional_Center_Outreach.jpg',
        caption: 'CCO 2025 — The Gospel of the Kingdom',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/nEuBSwSbwn3A542wFAB76w/Hospital_Outreach.jpg',
        caption: 'Hospital Outreach — March 2025, Christ Medical Center',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/g9dWR75XeKkNRPfzQmuCam/IMG_20250531_130837_349.jpg',
        caption: 'Orphanage Outreach — Kinglucy Orphanage Home',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/fiE12BJZ55CCWrWnWdQvVz/Orphanage_Outreach(1).jpg',
        caption: 'Orphanage Outreach — Kinglucy Orphanage Home',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/eDAzJqovYCz11ofrzhk1mM/Orphanage_Outreach.jpg',
        caption: 'Christ Love at Christmas — Orphanage Outreach',
      },
    ],
  },
  {
    year: 2026,
    title: 'The Journey Continues',
    description:
      'A new year, a new chapter — pressing forward in prayer, outreach, and unwavering faith.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/ijXcxNDUmirTMzvTCExJwZ/Market_Outreach.jpg',
        caption: 'Market Outreach 2026',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/9gb3dyZoWpSLxwuto3ZMvn/Hospital_Outreach_(1).jpg',
        caption: 'Hospital Outreach — Zimran Medical Centre, Benin City',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/eugH9WvNSEBrDamRh1F7vU/Hospital_Outreach_.jpg',
        caption: 'Hospital Outreach — Zimran Medical Centre, Benin City',
      },
    ],
  },
].filter((e) => e.year >= startYear && e.year <= currentYear)
